export default "/images/7b02f8da7f0e2decd4fe55a2a51e968f.avif";